import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  title: {
    id: 'product_jp_payment_methods',
    defaultMessage: 'Payment methods',
  },
  cards: {
    id: 'product_jp_payment_methods_cards',
    defaultMessage: 'Card (3D secure)',
  },
  konbini: {
    id: 'product_jp_payment_methods_konbini',
    defaultMessage: 'Konbini',
  },
  qrcode: {
    id: 'product_jp_payment_methods_qr_code',
    defaultMessage: 'QR code',
  },
} as Record<string, I18nDefinition>
